import {TStoreId} from "./sessionstore";

type TStoreItem = { data: string, expires: string | null }

export namespace nsAmplify {

    export const PREFIX = '__amplify__'

    export function store(storeId?: TStoreId | string, value?: any): any {
        try {
            return _store(storeId, value)
        } catch (e) {
            console.log(`Quota exceeded - flushing local storage`);
            // clear storage and try again
            window.localStorage.clear()
            return _store(storeId, value)
        }
    }

    function _store(storeId?: TStoreId | string, value?: any): any {
        // if no parameters are given we'll return the whole store (non prefixed)
        if (storeId === undefined && value === undefined) {
            const keys = Object.keys(window.localStorage)
            return keys
                .filter(k => k.startsWith(PREFIX))
                .reduce((obj: any, k) => {
                    const keyNonPrefixed = k.substring(PREFIX.length)
                    obj[keyNonPrefixed] = window.localStorage.getItem(k)
                    return obj
                }, {})
        }
        const _storeId = PREFIX + storeId
        if (value === undefined) {
            // if no value is given we'll return the stored value (or undefined)
            const str = window.localStorage.getItem(_storeId);
            if (str === null) {
                return undefined
            }
            let ret: TStoreItem | undefined
            try {
                ret = JSON.parse(str) as TStoreItem
            } catch {
                return undefined
            }
            try {
                return JSON.parse(ret.data)
            } catch {
            }
            return ret.data ?? undefined
        } else if (value === null) {
            // if value is null then remove the item all together
            window.localStorage.removeItem(_storeId)
        } else {
            // otherwise store the given value
            const data = typeof value === 'object' ? JSON.stringify(value) : value
            const obj: TStoreItem = {
                data: data,
                expires: null,
            }
            window.localStorage.setItem(_storeId, JSON.stringify(obj))
        }
    }

}